/* eslint-disable react/no-find-dom-node */
import { Component } from 'react'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import isEqual from 'lodash/isEqual'

import Typography from '../Typography'
import classNames from './styles.module.scss'


let c3 = {}
let d3 = {}

if(typeof window !== 'undefined') {
  c3 = require('c3')
  d3 = require('d3')
}


const propTypes = {
  columns: PropTypes.array,
  chartType: PropTypes.string,
  colors: PropTypes.object,
  title: PropTypes.string,
}

const defaultProps = {
  columns: [],
  chartType: 'pie',
  colors: {},
  title: undefined,
}

class Chart extends Component {
  componentDidMount() {
    this._updateChart()
  }

  shouldComponentUpdate(nextProps) {
    if(!isEqual(this.props.columns, nextProps.columns) || !isEqual(this.props.colors, nextProps.colors)) {
      this._updateChart()
    }
    return false
  }

  _updateChart() {
    const chart = c3.generate({
      bindto: findDOMNode(this) ? findDOMNode(this).querySelector('.chart') : undefined,
      size: {
        height: 238,
        width: 238,
      },
      data: {
        columns: this.props.columns,
        type: this.props.chartType,
        colors: this.props.colors,
      },
      tooltip: {
        contents: function(d) {
          return `<div class="tooltipChart">${d[0].id}</div>`
        },
      },
      legend: {
        show: false,
      },
      pie: {
        label: {
          threshold: 0.1,
          format: function(_) {
            return null
          },
        },
      },
    })

    if(findDOMNode(this)) {
      d3.select(findDOMNode(this).querySelector('.legendWrapper')).selectAll('*').remove()
      d3.select(findDOMNode(this).querySelector('.legendWrapper'))
        .append('ul', ':first-child')
        .attr('class', 'legend')
        .selectAll('span')
        .data(this.props.columns)
        .enter().append('li')
        .attr('data-id', function(id) {
          return id[0]
        })
        .attr('class', 'legendItem')
        .html(function(value) {
          return `${value[0]} ${value[1]}%`
        })
        .each(function(id) {
          d3.select(this).insert('span').attr('class', 'legendColor').style('background-color', chart.color(id[0]))
        })
        .on('mouseover', function(id) {
          chart.focus(id)
        })
        .on('mouseout', function() {
          chart.revert()
        })
    }
  }

  render() {
    if((typeof window === 'undefined')) {
      return null
    }
    return (
      <div>
        {this.props.title && (
          <Typography
            variant="block-title"
            transform="uppercase"
          >
            {this.props.title}
          </Typography>
        )}
        <Row className={classNames.chart}>
          <Col
            span={24}
            sm={16}
            lg={12}
          >
            <div className="legendWrapper" />
          </Col>
          <Col
            span={24}
            sm={8}
            lg={12}
          >
            <div className="chart" />
          </Col>
        </Row>
      </div>
    )
  }
}

Chart.defaultProps = defaultProps
Chart.propTypes = propTypes

export default Chart
